<template>
  <div class="grid-container">
    <div class="glasses">
      <GlassesSvg/>
    </div>
    <div class="heading">I'm a developer.</div>
    <div class="summary">
      <p>I am a software engineer with 4 years of industry experience in making modern web applications.</p>
      <p>I enjoy working with Javascript and everything related to front-end. I'm currently learning and practicing Vue and React.</p>
      <p>I'm still working on this site.</p>
    </div>
    <div class="keyboard" ref="keyboard">
      <KeyboardSvg/>
    </div>
    <div class="learn-more"><a href="https://www.linkedin.com/in/lizette-joan-daluz/" target="_blank">Check out my profile</a></div>
  </div>
</template>

<script>
import GlassesSvg from '../components/GlassesSvg';
import KeyboardSvg from '../components/KeyboardSvg';

export default {
  name: 'ProfileSection',
  components: {
    GlassesSvg,
    KeyboardSvg,
  },
  mounted: function() {
    const observer = this.createObserver();
    observer.observe(this.$refs["keyboard"]);
  },
  methods: {
    buildThresholdList: function() {
      const thresholds = [];
      const numSteps = 20;

      for (let i=1.0; i<=numSteps; i++) {
        const ratio = i/numSteps;
        thresholds.push(ratio);
      }

      thresholds.push(0);
      return thresholds;
    },
    createObserver: function() {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: this.buildThresholdList()
      };
      const observer = new IntersectionObserver(this.triggerAnimations, options);
      return observer;
    },
    triggerAnimations: function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains("animate")) {
          entry.target.className += " animate";
        }
      });
    }
  }
}
</script>

<style scoped>
.grid-container {
  display: grid;
  width: 100%;
  grid-template-rows: auto auto 200px auto;
}

.learn-more {
  display: flex;
}

.learn-more a {
  color: #2D2D2D;
}

.glasses {
  display: none;
}

.heading {
  font-size: 1.5rem;
  font-weight: bold;
  grid-row-start: 1;
  grid-row-end: 2;
  align-self: end;
}

.summary {
  grid-row-start: 2;
  grid-row-end: 3;
}

.keyboard {
  grid-row-start: 3;
  grid-row-end: 4;
  align-self: end;
}

.learn-more {
  grid-row-start: 4;
  grid-row-end: 5;
  align-self: baseline;
  padding-top: 1rem;
}

@media screen and (min-width: 768px) {
  .grid-container {
    grid-template-rows: 200px 200px 200px auto 100px;
    grid-template-columns: 200px 200px 150px auto auto;
  }

  .glasses {
    display: block;
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 2;
    grid-column-end: 3;
  }

  .heading {
    font-size: 2rem;
    font-weight: bold;
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 4;
    grid-column-end: 6;
    align-self: center;
    justify-self: center;
  }

  .keyboard {
    grid-row-start: 4;
    grid-row-end: 6;
    grid-column-start: 3;
    grid-column-end: 4;
    align-self: end;
    justify-self: end;
  }

  .summary {
    grid-row-start: 3;
    grid-row-end: 6;
    grid-column-start: 1;
    grid-column-end: 3;
    max-width: 300px;
    padding-top: 0;
  }

  .learn-more {
    grid-row-start: 5;
    grid-row-end: 6;
    grid-column-start: 5;
    grid-column-end: 6;
    justify-self: end;
  }
}

@media screen and (min-width: 768px) and (min-height: 768px) {
  .grid-container {
    grid-template-rows: 200px 100px 200px auto 100px;
  }
}

@media screen and (min-width: 768px) and (min-height: 800px) {
  .grid-container {
    grid-template-rows: 200px 200px 200px auto 100px;
  }
}

</style>

